import { createContext } from 'react';
import { ISessionChatCtx } from '../interfaces/ISessionChatCtx';

const SessionChatCtx = createContext<ISessionChatCtx | null>(null);

export default SessionChatCtx;
